import type { en } from './en'

export const it: Record<keyof typeof en, string> = {
  'LoginButton.Label': 'Accedi con Zucchetti Hospitality',
  'LoginButton.Loading': 'Accesso in corso…',
  'LoginButton.InfoTitle': 'Cosa sono le credenziali Zucchetti Hospitality?',
  'LoginButton.InfoDescription':
    "Sono l'account unico Zucchetti Hospitality, fornito da ZIdentity, con cui accedi ai servizi abilitati. Usa le stesse credenziali aziendali già in uso negli altri applicativi Zucchetti Hospitality.",
  'StepUp.Brand': 'Zucchetti Hospitality',
  'StepUp.Title': 'Verifica la tua identità',
  'StepUp.Totp.Prompt':
    'Questa operazione richiede una verifica aggiuntiva. Inserisci il codice di autenticazione del tuo account Zucchetti Hospitality per continuare.',
  'StepUp.Totp.CodeLabel': 'Codice di autenticazione',
  'StepUp.EmailOtp.Prompt':
    "Questa operazione richiede una verifica aggiuntiva. Ti abbiamo inviato un codice di verifica all'indirizzo email del tuo account Zucchetti Hospitality. Inseriscilo qui sotto per continuare.",
  'StepUp.EmailOtp.CodeLabel': 'Codice di verifica',
  'StepUp.EmailOtp.NoCode': 'Non hai ricevuto il codice?',
  'StepUp.EmailOtp.Resend': 'Invia di nuovo',
  'StepUp.Submit': 'Verifica',
  'StepUp.Discovering': 'Caricamento…',
  'StepUp.Submitting': 'Verifica in corso…',
  'StepUp.Cancel': 'Annulla',
  'StepUp.Close': 'Chiudi',
  'StepUp.Error.InvalidCode': 'Codice non valido. Riprova.',
  'StepUp.Error.RateLimited': 'Troppi tentativi. Riprova più tardi.',
  'StepUp.Error.InvalidAccessToken': 'La tua sessione è scaduta. Accedi di nuovo.',
  'StepUp.Error.NotEnabled': 'La verifica step-up non è disponibile per questa applicazione.',
  'StepUp.Error.Network': 'Si è verificato un errore. Controlla la connessione e riprova.',
}
